import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {PoliciesAlertsService} from "../../services/policies-alerts.service";
import {PoliciesDialogService} from "../../services/policies-dialogs-service.service";
import {PoliciesRequestsService} from "../../services/policies-requests.service";
import {PoliciesService} from "../../services/policies-service.service";
import {SettingsService} from "../../../site-preferences/services/settings-service.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {SortType} from "../../../commons/types/sort.type";
import {AdminDialogService} from "../../../admins/services/admin-dialogs-service.service";
import {SitesService} from "../../../sites/services/sites.service";

export class policyUsersViewCtrl implements IController {

  extendedPolicy: any;
  orgId: any;
  siteId: any;

  rolesGroups: any;
  private queryString: any;
  private loading: any;
  public users: any[];
  public selectedSortValue: any;
  public sortTypesValues: any;
  public isShowLastActiveColumn: any;
  public branchIds: string[];
  public tags: string[];

  /* @ngInject */
  constructor(private confirmDialogService: ConfirmDialogService, private $log, private $state,
              private policiesAlertsService: PoliciesAlertsService, private policiesDialogService: PoliciesDialogService,
              private policiesRequestsService: PoliciesRequestsService, private sitesService: SitesService,
              private policiesService: PoliciesService, private splitService: SplitService ,private adminDialogService: AdminDialogService, private IamRequests) {
  }

  $onInit() {

    this.users = angular.copy(this.extendedPolicy.users);
    this.loading = false;

    this.isShowLastActiveColumn = this.splitService.getReportUserLastActive();

    this.sortTypesValues = {
      sortLastActive: {asc: 'lastActive,asc', desc: 'lastActive,desc'},
    };

    if (this.extendedPolicy) {
      this.policiesService.getAllRolesGroups(this.extendedPolicy.policy.id, this.orgId, this.siteId)
        .then((groups: any) => {
          this.rolesGroups = groups;
        });
    }
  }

  /////////////////////////////////////////////////////////////////

  submitQuery(query) {
    this.queryString = query;
  }

  onTagsChange(tags: string[]) {
    this.tags = tags;

    if (this.branchIds?.length) {
      this.branchIds = [];
      this.getPolicy();
    }

  }

  onBranchesChange(branchIds) {
    this.branchIds = branchIds;
    this.getPolicy();
  }

  onAddUser(event) {
    this.policiesDialogService.addUser(event, this.extendedPolicy.roles, this.rolesGroups, this.extendedPolicy.policy.passwordPolicy)
      .then((userToAdd) => {
        this._addUser(userToAdd);
      })
      .catch(() => {

      })
  }

  onImportUsers() {
    this.$state.go('policy-users-upload');
  }

  onSortTypeChange(sortName) {
    const isSameSortName = !!this.selectedSortValue && _.isEqual(this.selectedSortValue.name, sortName);
    const newType = isSameSortName ? _.isEqual(this.selectedSortValue.type, SortType.asc) ? SortType.desc : SortType.asc : SortType.asc;

    this.selectedSortValue = {
      name: sortName,
      type: isSameSortName ? newType : SortType.asc,
      value: isSameSortName ? this.sortTypesValues[sortName][newType] : this.sortTypesValues[sortName].asc
    }

    if (this.selectedSortValue.name === 'sortLastActive') {
      if (this.selectedSortValue.type === SortType.asc) {
        this.users.sort((a, b) => {
          return _.get(b, 'lastActiveDate', 0) - _.get(a, 'lastActiveDate', 0)
        });
      } else {
        this.users.sort((a, b) => {
          return _.get(a, 'lastActiveDate', 0) - _.get(b, 'lastActiveDate', 0)
        });
      }
    }
    this.users = angular.copy(this.users);

  }

  onEditUser(user, event) {
    this.adminDialogService.editUser(event, user)
      .then((payload) => {
        this.loading = true;
        return this.IamRequests.editUser(user.id, payload.user, this.orgId, this.siteId, this.extendedPolicy.policy.id, payload.expirationDays, payload.removeExpiration);
      })
      .then((updatedUser) => {
        this.policiesAlertsService.updateInfoSuccess();
        const usersCopy = angular.copy(this.users);

        const userIndex = usersCopy.findIndex(u => u.id === user.id);
        usersCopy.splice(userIndex, 1, updatedUser);
        this.users = usersCopy;
      })
      .catch((error) => {
        if (error) {
          this.policiesAlertsService.updateInfoError();
          this.$log.error('Failed to update admin user profile @adminUserView@onEditUser', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }


  onEditPolicy(user, userRoles, userGroups, event) {
    const userGroupIds = _.map(userGroups, 'id');
    this.policiesDialogService.editUserRoles(event, user, userRoles, this.extendedPolicy.roles, userGroupIds, this.rolesGroups)
      .then((bindings: { roleId?: string[], rolesGroupId?: string[] }[]) => {
        this.loading = true;
        return this.policiesRequestsService.editUserBindings(
          this.extendedPolicy.policy.id,
          user.id,
          bindings,
          this.orgId,
          this.siteId
        );
      })
      .then((updatedUserBindings) => {
        this.policiesAlertsService.updateRolesSuccess();

        let bindingsCopy = angular.copy(this.extendedPolicy.policy.bindings);
        bindingsCopy = bindingsCopy.filter((b) => {
          return b.memberId !== user.id;
        })

        bindingsCopy = bindingsCopy.concat(updatedUserBindings.bindings);
        this.extendedPolicy.policy.bindings = bindingsCopy;
      })
      .catch((error) => {
        if (error) {
          this.policiesAlertsService.updateRolesError();
          this.$log.error('Failed to update policy @adminUserView@onEditRoles', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  onRemoveUser(user, event) {
    this.confirmDialogService.confirm('Remove User', 'Are you sure you want to remove this user?', event)
      .then(() => {
        this._removeUser(user);
      })
      .catch(() => {

      })
  }

  private getPolicy() {
    this.sitesService.getSitePolicy(this.siteId, this.branchIds)
      .then((extendedPolicy) => {
        this.extendedPolicy = angular.copy(extendedPolicy)
        this.users = angular.copy(this.extendedPolicy.users);
      })
  }

  private _addUser(user) {
    this.policiesService.addUser(this.extendedPolicy.policy.id, user, this.orgId, this.siteId)
      .then((res: any) => {
        this.extendedPolicy.policy.bindings = this.extendedPolicy.policy.bindings.concat(res.bindings);

        const currentIndex = this.extendedPolicy.users.findIndex((u) => {
          return u.id === res.user.id;
        });

        if (currentIndex === -1) {
          const usersCopy = angular.copy(this.extendedPolicy.users);
          usersCopy.unshift(res.user);
          this.extendedPolicy.users = usersCopy;
        }

        this.users = angular.copy(this.extendedPolicy.users);

      })
  }

  private _removeUser(user) {
    this.policiesService.deleteUser(this.extendedPolicy.policy.id, user.id, this.orgId, this.siteId)
      .then(() => {
        this.extendedPolicy.users = _.filter(this.extendedPolicy.users, (policyUser) => {
          return policyUser.id !== user.id;
        });

        this.users = angular.copy(this.extendedPolicy.users);
      })
  }

}

angular
  .module('bringoz.admin.policies')
  .component('policyUsersView', {
    bindings: {
      extendedPolicy: '<',
      orgId: '<?',
      siteId: '<?'
    },
    template: require('./policy-users-view.html').default,
    controller: policyUsersViewCtrl
  });
